import type { ChallengeDetails } from '@assembly-web/services';
import { twMerge } from 'tailwind-merge';

import { TextStyle } from '../../../DesignSystem/Feedback/TextStyle';
import { Challenge } from '../../assets/images';

type CardPreviewProps = {
  challengeDetails: ChallengeDetails;
};

export function CardPreview(props: CardPreviewProps) {
  const { challengeDetails } = props;
  return (
    <div className="mt-3 flex w-full items-center gap-4">
      <div
        className={twMerge(
          'relative flex h-[89px] w-[115px] shrink-0 items-center justify-center overflow-hidden rounded-lg border border-gray-5'
        )}
      >
        {challengeDetails.image ? (
          <img
            alt="challenge-submission-modal-preview"
            src={challengeDetails.image}
            className="object-cover"
          />
        ) : (
          <div
            className={
              'flex h-full w-full items-center justify-center bg-upgrade-3'
            }
          >
            <img
              src={Challenge}
              alt="default-challenge-card-preview"
              className="max-w-[50%] object-cover"
            />
          </div>
        )}
      </div>
      <div>
        <TextStyle variant="base-medium">{challengeDetails.title}</TextStyle>
        {Boolean(challengeDetails.description) && (
          <TextStyle variant="xs-regular" className="text-gray-8">
            {challengeDetails.description}
          </TextStyle>
        )}
      </div>
    </div>
  );
}
